<div
  class="main-nav-platform-desktop-items"
  data-cy="main-nav-menu-items">
  <a
    class="main-nav-platform-desktop-logo"
    [routerLink]="items.home.link">
    <img
      src="/assets/images/logo/logo-smarthead-turquoise.svg"
      title="SmartHead" />
  </a>

  @if (!!(mainNavService.hasProfile$ | async)) {
    <sh-main-nav-profiles-desktop [profiles]="(mainNavService.profileWhereUserAdmin$ | async) ?? []"> </sh-main-nav-profiles-desktop>
  }
  <div class="spacer"></div>

  <div class="main-nav-platform-desktop-search-container">
    <sh-search-input></sh-search-input>
  </div>

  <sh-main-nav-single-item [item]="items.newsfeedItem"></sh-main-nav-single-item>

  @if (mainNavService.requests$ | async; as requests) {
    <sh-main-nav-single-item [item]="requests"></sh-main-nav-single-item>
  }

  <!-- NOTE: info is replaced by requests, but not removed yet -->
  <!-- <a
    *ngIf="mainNavService.inbox$ | async as inbox"
    data-cy="main-nav-inbox"
    class="main-nav-platform-desktop-inbox"
    [routerLink]="inbox.link"
    [routerLinkActive]="['active']">
    <label>{{ 'header.inbox' | transloco }}</label>
    <div
      *ngIf="inbox.notificationCount > 0"
      class="counter">
      {{ inbox.notificationCount }}+
    </div>
  </a> -->

  @if (loadedProfileSubscription$ | async; as profileSubscription) {
    <a
      target="_blank"
      [href]="knowledgeBaseURL">
      <ui-icon
        key="tutorials"
        nz-tooltip
        nzTooltipPlacement="bottom"
        [nzTooltipTitle]="'profile.admin.dashboard.tutorials.button' | transloco"
        (click)="onBecameEsgProBtnClick(profileSubscription.profileId, profileSubscription.type)"></ui-icon>
    </a>
  }
  @if (mainNavService.loggedUser$ | async; as loggedUser) {
    <sh-main-nav-user [loggedUser]="loggedUser"> </sh-main-nav-user>
  }

  @if ((mainNavService.loggedUser$ | async) === undefined) {
    <sh-main-nav-login></sh-main-nav-login>
    <sh-main-nav-languages></sh-main-nav-languages>
  }

  @if ((mainNavService.hasProfile$ | async) === false) {
    <a
      class="for-companies"
      [href]="items.businessRootItem.link">
      {{ 'header.business-page' | transloco }}
    </a>
  }
</div>
